import React from 'react';
import {Provider as StoreProvider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import {App as CapacitorApp} from '@capacitor/app';
import {Capacitor} from '@capacitor/core';
import {StatusBar, Style} from '@capacitor/status-bar';
import CssBaseline from "@mui/material/CssBaseline";
import {DrawerMenu} from "./components/core/drawerMenu/DrawerMenu";
import {AppRoutes} from "./pages/AppRoutes";
import {Experimental_CssVarsProvider as CssVarsProvider} from '@mui/material/styles';
import theme from "./theme";
import {AnimatedBackground} from "./components/core/animatedBackground/AnimatedBackground";
import store, {persistor} from "./store/store";
import Player from "./components/core/player/Player";
import styles from './App.module.scss';
import {BottomNav} from "./components/core/bottomNav/BottomNav";
import {PersistGate} from "redux-persist/integration/react";
import {AuthProvider} from "./auth/AuthContext";
import {FirestorePlaylistSync} from "./auth/FirestorePlaylistSync";
import {FirestoreUserDataSync} from "./auth/FirestoreUserDataSync";

const App: React.FC = () => {

    React.useEffect(() => {
        const backListener = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
            if (canGoBack) {
                window.history.back();
            } else {
                // If there's truly no history left, then exit
                CapacitorApp.exitApp();
            }
        });

        if (Capacitor.isNativePlatform()) {
            StatusBar.setBackgroundColor({ color: '#201a37' }).catch(() => {});
            StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
            StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
        }

        return () => {
            backListener.then(l => l.remove());
        };
    }, []);


    return (
        <StoreProvider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <CssVarsProvider theme={theme}>
                    <BrowserRouter>
                        <AuthProvider>
                            <FirestorePlaylistSync/>
                            <FirestoreUserDataSync/>
                            <div className={styles.app__container}>
                                <div className={styles.app__main}>
                                    <CssBaseline/>
                                    <div className={styles.app__drawerMenu}><DrawerMenu/></div>
                                    <div className={styles.app__content}><AppRoutes/></div>
                                    <AnimatedBackground/>
                                </div>

                                <div className={styles.app__footer}>
                                    <div className={styles.app__player}><Player/></div>
                                    <div className={styles.app__bottomNav}><BottomNav/></div>
                                </div>
                            </div>
                        </AuthProvider>
                    </BrowserRouter>
                </CssVarsProvider>
            </PersistGate>
        </StoreProvider>
    );
};

export default App;
